import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router';
import PropTypes from 'prop-types';
import { Button } from 'antd';

import UsuariFormulari from './usuariFormulari';
import UsuariDetallDonarDeBaixa from './usuariDetallDonarDeBaixa';
import UsuariDetallDonarDeAlta from './usuariDetallDonarDeAlta';
import UsuariDetallRestablirContrasenya from './usuariDetallRestablirContrasenya';

import errorBoundaryWrapper from '../commons/errorBoundaryWrapper';
import { rutaUsuaris, rutaEdicioUsuaris } from '../../routes/routeConstants';
import {
    selectorFormulariDadesEsActiu,
    selectorFormulariIdUsuariSeleccionat
} from '../../selectors/selector_usuari';

class UsuariDetall extends Component {

    generarBotoDonarDeBaixa(idUsuari) {
        return <UsuariDetallDonarDeBaixa idUsuari={idUsuari} />;
    }

    generarBotoDonarDeAlta(idUsuari) {
        return <UsuariDetallDonarDeAlta idUsuari={idUsuari} />;
    }

    generarBotoRestablirContrasenya(idUsuari) {
        return <UsuariDetallRestablirContrasenya idUsuari={idUsuari} />;
    }

    generarBotoEditar() {
        return (
            <Link to={rutaEdicioUsuaris}>
                <Button type='primary' size='large'>
                    Editar
                </Button>
            </Link>
        );
    }

    generarBotoTornar() {
        return (
            <Link to={rutaUsuaris}>
                <Button icon='left'>
                    Tornar
                </Button>
            </Link>
        );
    }

    render() {

        const { usuariEsActiu, idUsuari } = this.props;

        const botoAltaBaixaUsuari = (usuariEsActiu) ? this.generarBotoDonarDeBaixa(idUsuari) : this.generarBotoDonarDeAlta(idUsuari);
        const botoRestablirContrasenya = this.generarBotoRestablirContrasenya(idUsuari);
        const botoEditar = this.generarBotoEditar();
        const botoTornar = this.generarBotoTornar();

        return (
            <div className='usuari-introduccio-i-detall'>
                { botoTornar }
                <div className='usuari-introduccio-i-detall-contenidor'>
                    <UsuariFormulari esEditable={false} />
                </div>
                <div className='usuari-introduccio-i-detall-botons'>
                    { botoEditar }
                    { botoRestablirContrasenya }
                    { botoAltaBaixaUsuari }
                </div>
            </div>
        );
    }
}

UsuariDetall.propTypes = {
    usuariEsActiu: PropTypes.bool.isRequired,
    idUsuari: PropTypes.number.isRequired
};

const mapStateToProps = (state) => {
    return {
        usuariEsActiu: selectorFormulariDadesEsActiu(state),
        idUsuari: selectorFormulariIdUsuariSeleccionat(state)
    };
};

export default errorBoundaryWrapper(connect(mapStateToProps, null)(UsuariDetall));


// WEBPACK FOOTER //
// ./src/components/usuari/usuariDetall.js